// Grade 2026/02 transcrita dos PDFs da UNIFENAS-BH.
// O campo sourcePdf preserva as tabelas e o texto extraídos, inclusive escalas de ambulatório.
// As datas dos blocos vêm do calendário já cadastrado em ../data.js; os PDFs de horário não as informam.
// O bloco 1 vem de Emergências Clínicas e Trauma; a rotação dos blocos 2–4 foi confirmada pela turma.
import sourcePdf from "./sources/period8.json";
import { period8Seminars } from "./period8Seminars.js";
import { period8Exams } from "./period8Exams.js";
import { SYNDROMES, BLOCKS, DEFAULT_ROTATIONS, BASE_SCHEDULE, FIXED_CLINICS, SPECIALTY_CLINICS } from "../data.js";
import { EXTRA_CATALOG } from "../catalog.js";
const periodDataset = {
  label: "8º período",
  syndromes: { ...SYNDROMES, emergencias: {
  "name": "Emergências Clínicas e Trauma",
  "short": "Emergências"
} },
  blocks: BLOCKS,
  datedEvents: Object.fromEntries([...new Set([...Object.keys(period8Seminars), ...Object.keys(period8Exams)])]
    .map((iso) => [iso, [...(period8Seminars[iso] || []), ...(period8Exams[iso] || [])]])),
  defaultRotations: Object.fromEntries(Object.entries(DEFAULT_ROTATIONS).map(([letter, order]) => [letter, { 1: "emergencias", ...order }])),
  baseSchedule: { ...BASE_SCHEDULE, emergencias: {
  "1": {
    "am1": {
      "1": {
        "code": "TP",
        "title": "Tempo protegido",
        "professor": "",
        "location": "",
        "kind": "tp"
      },
      "2": {
        "code": "TP",
        "title": "Tempo protegido",
        "professor": "",
        "location": "",
        "kind": "tp"
      },
      "3": {
        "code": "PL",
        "title": "Prática de laboratório",
        "professor": "Denise",
        "location": "Lab. Morfo",
        "kind": "pl"
      },
      "4": {
        "code": "PL",
        "title": "Prática de laboratório",
        "professor": "Carmona",
        "location": "funcional",
        "kind": "pl"
      }
    },
    "am2": {
      "1": {
        "code": "PL",
        "title": "Prática de laboratório",
        "professor": "Denise",
        "location": "Lab. Morfo",
        "kind": "pl"
      },
      "2": {
        "code": "PL",
        "title": "Prática de laboratório",
        "professor": "Carmona",
        "location": "funcional",
        "kind": "pl"
      },
      "3": {
        "code": "TP",
        "title": "Tempo protegido",
        "professor": "",
        "location": "",
        "kind": "tp"
      },
      "4": {
        "code": "TP",
        "title": "Tempo protegido",
        "professor": "",
        "location": "",
        "kind": "tp"
      }
    },
    "pm1": {
      "1": {
        "code": "GT",
        "title": "Grupo tutorial",
        "professor": "Paula C",
        "location": "206",
        "kind": "gt"
      },
      "2": {
        "code": "GT",
        "title": "Grupo tutorial",
        "professor": "Rogério",
        "location": "208",
        "kind": "gt"
      },
      "3": {
        "code": "GT",
        "title": "Grupo tutorial",
        "professor": "Rita",
        "location": "209",
        "kind": "gt"
      },
      "4": {
        "code": "GT",
        "title": "Grupo tutorial",
        "professor": "Deborah",
        "location": "211",
        "kind": "gt"
      }
    },
    "pm2": {
      "1": {
        "code": "GT",
        "title": "Grupo tutorial",
        "professor": "Paula C",
        "location": "206",
        "kind": "gt"
      },
      "2": {
        "code": "GT",
        "title": "Grupo tutorial",
        "professor": "Rogério",
        "location": "208",
        "kind": "gt"
      },
      "3": {
        "code": "GT",
        "title": "Grupo tutorial",
        "professor": "Rita",
        "location": "209",
        "kind": "gt"
      },
      "4": {
        "code": "GT",
        "title": "Grupo tutorial",
        "professor": "Deborah",
        "location": "211",
        "kind": "gt"
      }
    }
  },
  "3": {
    "am1": {
      "1": {
        "code": "TP",
        "title": "Tempo protegido",
        "professor": "",
        "location": "",
        "kind": "tp"
      },
      "2": {
        "code": "TP",
        "title": "Tempo protegido",
        "professor": "",
        "location": "",
        "kind": "tp"
      },
      "3": {
        "code": "TP",
        "title": "Tempo protegido",
        "professor": "",
        "location": "",
        "kind": "tp"
      },
      "4": {
        "code": "TP",
        "title": "Tempo protegido",
        "professor": "",
        "location": "",
        "kind": "tp"
      }
    },
    "am2": {
      "1": {
        "code": "TP",
        "title": "Tempo protegido",
        "professor": "",
        "location": "",
        "kind": "tp"
      },
      "2": {
        "code": "TP",
        "title": "Tempo protegido",
        "professor": "",
        "location": "",
        "kind": "tp"
      },
      "3": {
        "code": "TP",
        "title": "Tempo protegido",
        "professor": "",
        "location": "",
        "kind": "tp"
      },
      "4": {
        "code": "TP",
        "title": "Tempo protegido",
        "professor": "",
        "location": "",
        "kind": "tp"
      }
    },
    "pm1": {
      "1": {
        "code": "GT",
        "title": "Grupo tutorial",
        "professor": "Paula C",
        "location": "206",
        "kind": "gt"
      },
      "2": {
        "code": "GT",
        "title": "Grupo tutorial",
        "professor": "Rogério",
        "location": "208",
        "kind": "gt"
      },
      "3": {
        "code": "GT",
        "title": "Grupo tutorial",
        "professor": "Rita",
        "location": "209",
        "kind": "gt"
      },
      "4": {
        "code": "GT",
        "title": "Grupo tutorial",
        "professor": "Deborah",
        "location": "211",
        "kind": "gt"
      }
    },
    "pm2": {
      "1": {
        "code": "GT",
        "title": "Grupo tutorial",
        "professor": "Paula C",
        "location": "206",
        "kind": "gt"
      },
      "2": {
        "code": "GT",
        "title": "Grupo tutorial",
        "professor": "Rogério",
        "location": "208",
        "kind": "gt"
      },
      "3": {
        "code": "GT",
        "title": "Grupo tutorial",
        "professor": "Rita",
        "location": "209",
        "kind": "gt"
      },
      "4": {
        "code": "GT",
        "title": "Grupo tutorial",
        "professor": "Deborah",
        "location": "211",
        "kind": "gt"
      }
    }
  },
  "4": {
    "am1": {
      "1": {
        "code": "TH",
        "title": "Treinamento de habilidades",
        "professor": "Mário G",
        "location": "TH 05",
        "kind": "th"
      },
      "2": {
        "code": "TP",
        "title": "Tempo protegido",
        "professor": "",
        "location": "",
        "kind": "tp"
      },
      "3": {
        "code": "TH",
        "title": "Treinamento de habilidades",
        "professor": "Mário G",
        "location": "TH 05",
        "kind": "th"
      },
      "4": {
        "code": "TP",
        "title": "Tempo protegido",
        "professor": "",
        "location": "",
        "kind": "tp"
      }
    },
    "am2": {
      "1": {
        "code": "TP",
        "title": "Tempo protegido",
        "professor": "",
        "location": "",
        "kind": "tp"
      },
      "2": {
        "code": "TH",
        "title": "Treinamento de habilidades",
        "professor": "Mário G",
        "location": "TH 05",
        "kind": "th"
      },
      "3": {
        "code": "TP",
        "title": "Tempo protegido",
        "professor": "",
        "location": "",
        "kind": "tp"
      },
      "4": {
        "code": "TH",
        "title": "Treinamento de habilidades",
        "professor": "Mário G",
        "location": "TH 05",
        "kind": "th"
      }
    },
    "pm1": {
      "1": {
        "code": "PE",
        "title": "Projeto em equipe / metodologias ativas",
        "professor": "Renata Lima a conf.",
        "location": "CEASC",
        "kind": "pe"
      },
      "2": {
        "code": "PE",
        "title": "Projeto em equipe / metodologias ativas",
        "professor": "Renata Lima a conf.",
        "location": "CEASC",
        "kind": "pe"
      },
      "3": {
        "code": "PE",
        "title": "Projeto em equipe / metodologias ativas",
        "professor": "Renata Lima a conf.",
        "location": "CEASC",
        "kind": "pe"
      },
      "4": {
        "code": "PE",
        "title": "Projeto em equipe / metodologias ativas",
        "professor": "Renata Lima a conf.",
        "location": "CEASC",
        "kind": "pe"
      }
    },
    "pm2": {
      "1": {
        "code": "TP",
        "title": "Tempo protegido",
        "professor": "",
        "location": "",
        "kind": "tp"
      },
      "2": {
        "code": "TP",
        "title": "Tempo protegido",
        "professor": "",
        "location": "",
        "kind": "tp"
      },
      "3": {
        "code": "TP",
        "title": "Tempo protegido",
        "professor": "",
        "location": "",
        "kind": "tp"
      },
      "4": {
        "code": "TP",
        "title": "Tempo protegido",
        "professor": "",
        "location": "",
        "kind": "tp"
      }
    }
  },
  "2": {
    "am1": {
      "4": {
        "code": "AF",
        "title": "Ambulatório fixo",
        "professor": "",
        "location": "",
        "kind": "placeholder",
        "accepts": [
          "fixed"
        ]
      }
    },
    "am2": {
      "2": {
        "code": "AMB",
        "title": "Ambulatório ou tempo protegido · consultar escala",
        "professor": "",
        "location": "",
        "kind": "placeholder",
        "accepts": [
          "fixed",
          "specialty"
        ]
      },
      "3": {
        "code": "AMB",
        "title": "Ambulatório ou tempo protegido · consultar escala",
        "professor": "",
        "location": "",
        "kind": "placeholder",
        "accepts": [
          "fixed",
          "specialty"
        ]
      },
      "4": {
        "code": "AMB",
        "title": "Ambulatório ou tempo protegido · consultar escala",
        "professor": "",
        "location": "",
        "kind": "placeholder",
        "accepts": [
          "fixed",
          "specialty"
        ]
      }
    },
    "pm1": {
      "4": {
        "code": "AF",
        "title": "Ambulatório fixo",
        "professor": "",
        "location": "",
        "kind": "placeholder",
        "accepts": [
          "fixed"
        ]
      }
    },
    "pm2": {
      "2": {
        "code": "AMB",
        "title": "Ambulatório ou tempo protegido · consultar escala",
        "professor": "",
        "location": "",
        "kind": "placeholder",
        "accepts": [
          "fixed",
          "specialty"
        ]
      },
      "3": {
        "code": "AMB",
        "title": "Ambulatório ou tempo protegido · consultar escala",
        "professor": "",
        "location": "",
        "kind": "placeholder",
        "accepts": [
          "fixed",
          "specialty"
        ]
      },
      "4": {
        "code": "AMB",
        "title": "Ambulatório ou tempo protegido · consultar escala",
        "professor": "",
        "location": "",
        "kind": "placeholder",
        "accepts": [
          "fixed",
          "specialty"
        ]
      }
    }
  },
  "5": {
    "am1": {
      "4": {
        "code": "AF",
        "title": "Ambulatório fixo",
        "professor": "",
        "location": "",
        "kind": "placeholder",
        "accepts": [
          "fixed"
        ]
      }
    },
    "am2": {
      "2": {
        "code": "AMB",
        "title": "Ambulatório ou tempo protegido · consultar escala",
        "professor": "",
        "location": "",
        "kind": "placeholder",
        "accepts": [
          "fixed",
          "specialty"
        ]
      },
      "3": {
        "code": "AMB",
        "title": "Ambulatório ou tempo protegido · consultar escala",
        "professor": "",
        "location": "",
        "kind": "placeholder",
        "accepts": [
          "fixed",
          "specialty"
        ]
      },
      "4": {
        "code": "AMB",
        "title": "Ambulatório ou tempo protegido · consultar escala",
        "professor": "",
        "location": "",
        "kind": "placeholder",
        "accepts": [
          "fixed",
          "specialty"
        ]
      }
    },
    "pm1": {
      "1": {
        "code": "TP",
        "title": "Tempo protegido",
        "professor": "",
        "location": "",
        "kind": "tp"
      },
      "2": {
        "code": "TP",
        "title": "Tempo protegido",
        "professor": "",
        "location": "",
        "kind": "tp"
      },
      "3": {
        "code": "TP",
        "title": "Tempo protegido",
        "professor": "",
        "location": "",
        "kind": "tp"
      },
      "4": {
        "code": "TP",
        "title": "Tempo protegido",
        "professor": "",
        "location": "",
        "kind": "tp"
      }
    },
    "pm2": {
      "1": {
        "code": "TP",
        "title": "Tempo protegido",
        "professor": "",
        "location": "",
        "kind": "tp"
      },
      "2": {
        "code": "TP",
        "title": "Tempo protegido",
        "professor": "",
        "location": "",
        "kind": "tp"
      },
      "3": {
        "code": "TP",
        "title": "Tempo protegido",
        "professor": "",
        "location": "",
        "kind": "tp"
      },
      "4": {
        "code": "TP",
        "title": "Tempo protegido",
        "professor": "",
        "location": "",
        "kind": "tp"
      }
    }
  }
} },
  baseScheduleByLetter: {
  "emergencias": {
    "A": {
      "1": {
        "am1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Denise",
            "location": "Lab. Morfo",
            "kind": "pl"
          },
          "4": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Carmona",
            "location": "funcional",
            "kind": "pl"
          }
        },
        "am2": {
          "1": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Denise",
            "location": "Lab. Morfo",
            "kind": "pl"
          },
          "2": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Carmona",
            "location": "funcional",
            "kind": "pl"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Paula C",
            "location": "206",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Rogério",
            "location": "208",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Rita",
            "location": "209",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Deborah",
            "location": "211",
            "kind": "gt"
          }
        },
        "pm2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Paula C",
            "location": "206",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Rogério",
            "location": "208",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Rita",
            "location": "209",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Deborah",
            "location": "211",
            "kind": "gt"
          }
        }
      },
      "3": {
        "am1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Paula C",
            "location": "206",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Rogério",
            "location": "208",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Rita",
            "location": "209",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Deborah",
            "location": "211",
            "kind": "gt"
          }
        },
        "pm2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Paula C",
            "location": "206",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Rogério",
            "location": "208",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Rita",
            "location": "209",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Deborah",
            "location": "211",
            "kind": "gt"
          }
        }
      },
      "4": {
        "am1": {
          "1": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Mário G",
            "location": "TH 05",
            "kind": "th"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Mário G",
            "location": "TH 05",
            "kind": "th"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Mário G",
            "location": "TH 05",
            "kind": "th"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Mário G",
            "location": "TH 05",
            "kind": "th"
          }
        },
        "pm1": {
          "1": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Renata Lima a conf.",
            "location": "CEASC",
            "kind": "pe"
          },
          "2": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Renata Lima a conf.",
            "location": "CEASC",
            "kind": "pe"
          },
          "3": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Renata Lima a conf.",
            "location": "CEASC",
            "kind": "pe"
          },
          "4": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Renata Lima a conf.",
            "location": "CEASC",
            "kind": "pe"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        }
      },
      "2": {
        "am1": {
          "4": {
            "code": "AF",
            "title": "Ambulatório fixo",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed"
            ]
          }
        },
        "am2": {
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        },
        "pm1": {
          "4": {
            "code": "AF",
            "title": "Ambulatório fixo",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed"
            ]
          }
        },
        "pm2": {
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        }
      },
      "5": {
        "am1": {
          "4": {
            "code": "AF",
            "title": "Ambulatório fixo",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed"
            ]
          }
        },
        "am2": {
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        },
        "pm1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        }
      }
    },
    "B": {
      "1": {
        "am1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Rafaela",
            "location": "201",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Paulo Boy",
            "location": "203",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Fernanda Issa",
            "location": "204",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Adriana S",
            "location": "205",
            "kind": "gt"
          }
        },
        "am2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Rafaela",
            "location": "201",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Paulo Boy",
            "location": "203",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Fernanda Issa",
            "location": "204",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Adriana S",
            "location": "205",
            "kind": "gt"
          }
        },
        "pm1": {
          "1": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Denise",
            "location": "Lab. Morfo",
            "kind": "pl"
          },
          "2": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Carmona",
            "location": "funcional",
            "kind": "pl"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Denise",
            "location": "Lab. Morfo",
            "kind": "pl"
          },
          "4": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Carmona",
            "location": "Lab. Morfo",
            "kind": "pl"
          }
        }
      },
      "3": {
        "am1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "TP",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "TP",
            "kind": "tp"
          }
        },
        "am2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "TP",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Eliana Horta",
            "location": "CEASC",
            "kind": "pe"
          },
          "2": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Eliana Horta",
            "location": "CEASC",
            "kind": "pe"
          },
          "3": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Eliana Horta",
            "location": "CEASC",
            "kind": "pe"
          },
          "4": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Eliana Horta",
            "location": "CEASC",
            "kind": "pe"
          }
        }
      },
      "4": {
        "am1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Rafaela",
            "location": "201",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Paulo Boy",
            "location": "203",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Fernanda Issa",
            "location": "204",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Adriana S",
            "location": "205",
            "kind": "gt"
          }
        },
        "pm2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Rafaela",
            "location": "201",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Paulo Boy",
            "location": "203",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Fernanda Issa",
            "location": "204",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Adriana S",
            "location": "205",
            "kind": "gt"
          }
        }
      },
      "5": {
        "am1": {
          "1": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Maria Cecília",
            "location": "TH 05",
            "kind": "th"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Maria Cecília",
            "location": "TH 05",
            "kind": "th"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Maria Cecília",
            "location": "TH 05",
            "kind": "th"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Maria Cecília",
            "location": "TH 05",
            "kind": "th"
          }
        },
        "pm1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        }
      },
      "2": {
        "am1": {
          "3": {
            "code": "AF",
            "title": "Ambulatório fixo",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed"
            ]
          }
        },
        "am2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        },
        "pm1": {
          "3": {
            "code": "AF",
            "title": "Ambulatório fixo",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        },
        "pm2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        }
      }
    },
    "C": {
      "1": {
        "am1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Eduardo",
            "location": "101",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Camilla F",
            "location": "106",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Nina",
            "location": "202",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Paulo Cruz",
            "location": "210",
            "kind": "gt"
          }
        },
        "am2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Eduardo",
            "location": "101",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Camilla F",
            "location": "106",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Nina",
            "location": "202",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Paulo Cruz",
            "location": "210",
            "kind": "gt"
          }
        },
        "pm1": {
          "1": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Maria Turci",
            "location": "CEASC",
            "kind": "pe"
          },
          "2": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Maria Turci",
            "location": "CEASC",
            "kind": "pe"
          },
          "3": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Maria Turci",
            "location": "CEASC",
            "kind": "pe"
          },
          "4": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Maria Turci",
            "location": "CEASC",
            "kind": "pe"
          }
        },
        "pm2": {
          "1": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Maria Turci",
            "location": "CEASC",
            "kind": "pe"
          },
          "2": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Maria Turci",
            "location": "CEASC",
            "kind": "pe"
          },
          "3": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Maria Turci",
            "location": "CEASC",
            "kind": "pe"
          },
          "4": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Maria Turci",
            "location": "CEASC",
            "kind": "pe"
          }
        }
      },
      "3": {
        "am1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Eduardo",
            "location": "101",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Camilla F",
            "location": "106",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Nina",
            "location": "202",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Paulo Cruz",
            "location": "210",
            "kind": "gt"
          }
        },
        "pm2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Eduardo",
            "location": "101",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Camilla F",
            "location": "106",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Nina",
            "location": "202",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Paulo Cruz",
            "location": "210",
            "kind": "gt"
          }
        }
      },
      "4": {
        "am1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm1": {
          "1": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Denise",
            "location": "Lab. Morfo",
            "kind": "pl"
          },
          "2": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Carmona",
            "location": "funcional",
            "kind": "pl"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Denise",
            "location": "Lab. Morfo",
            "kind": "pl"
          },
          "4": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Carmona",
            "location": "funcional",
            "kind": "pl"
          }
        }
      },
      "5": {
        "am1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Camilla F",
            "location": "TH 04",
            "kind": "th"
          },
          "4": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Camilla F",
            "location": "TH 04",
            "kind": "th"
          }
        },
        "am2": {
          "1": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Camilla F",
            "location": "TH 04",
            "kind": "th"
          },
          "2": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Camilla F",
            "location": "TH 04",
            "kind": "th"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        }
      },
      "2": {
        "am1": {
          "3": {
            "code": "AF",
            "title": "Ambulatório fixo",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed"
            ]
          }
        },
        "am2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        },
        "pm1": {
          "3": {
            "code": "AF",
            "title": "Ambulatório fixo",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed"
            ]
          }
        },
        "pm2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        }
      }
    }
  }
},
  fixedClinics: { ...FIXED_CLINICS, 1: {
  "A": {
    "1": {
      "day": 2,
      "period": "am",
      "code": "AF1",
      "title": "Pediatria",
      "professor": "Fernanda Ribeiro",
      "location": "Ambulatório da Igreja do Carmo Sion",
      "regional": "",
      "source": "fixed",
      "kind": "clinic"
    },
    "2": {
      "day": 2,
      "period": "pm",
      "code": "AF2",
      "title": "Pediatria",
      "professor": "Letícia Linhares",
      "location": "Centro de Saúde Boa Vista",
      "regional": "Leste",
      "source": "fixed",
      "kind": "clinic"
    },
    "3": {
      "day": 2,
      "period": "pm",
      "code": "AF3",
      "title": "Pediatria",
      "professor": "Marina Araújo",
      "location": "Ambulatório da Igreja do Carmo Sion",
      "regional": "",
      "source": "fixed",
      "kind": "clinic"
    },
    "4": {
      "day": 2,
      "period": "pm",
      "code": "AF4",
      "title": "Clínica Médica",
      "professor": "Eduardo Cordeiro",
      "location": "Centro de Saúde Santa Terezinha",
      "regional": "Pampulha",
      "source": "fixed",
      "kind": "clinic"
    },
    "5": {
      "day": 2,
      "period": "pm",
      "code": "AF5",
      "title": "Clínica Médica",
      "professor": "Henrique Barros",
      "location": "Centro de Saúde Lagoa",
      "regional": "Venda Nova",
      "source": "fixed",
      "kind": "clinic"
    },
    "6": {
      "day": 5,
      "period": "am",
      "code": "AF6",
      "title": "Cirurgia",
      "professor": "Pablo Hubner (contratação)",
      "location": "CEASC",
      "regional": "",
      "source": "fixed",
      "kind": "clinic"
    }
  },
  "B": {
    "1": {
      "day": 2,
      "period": "am",
      "code": "AF1",
      "title": "Pediatria",
      "professor": "Cristiano Bento",
      "location": "Centro de Saúde São Francisco",
      "regional": "Pampulha",
      "source": "fixed",
      "kind": "clinic"
    },
    "2": {
      "day": 2,
      "period": "pm",
      "code": "AF2",
      "title": "Pediatria",
      "professor": "Kátia Bueno",
      "location": "Centro de Saúde Santa Amélia",
      "regional": "Pampulha",
      "source": "fixed",
      "kind": "clinic"
    },
    "3": {
      "day": 2,
      "period": "pm",
      "code": "AF3",
      "title": "Pediatria",
      "professor": "Gabriele Rezende",
      "location": "Centro de Saúde Vila Maria",
      "regional": "Nordeste",
      "source": "fixed",
      "kind": "clinic"
    },
    "4": {
      "day": 2,
      "period": "pm",
      "code": "AF4",
      "title": "Clínica Médica",
      "professor": "Yara Santos",
      "location": "Ambulatório da Igreja do Carmo Sion",
      "regional": "",
      "source": "fixed",
      "kind": "clinic"
    },
    "5": {
      "day": 2,
      "period": "pm",
      "code": "AF5",
      "title": "Cirurgia",
      "professor": "Camila Godinho (contratação)",
      "location": "CEASC",
      "regional": "",
      "source": "fixed",
      "kind": "clinic"
    }
  },
  "C": {
    "1": {
      "day": 2,
      "period": "am",
      "code": "AF1",
      "title": "Pediatria",
      "professor": "Giovanna Fonseca",
      "location": "Centro de Saúde Santa Rosa",
      "regional": "Pampulha",
      "source": "fixed",
      "kind": "clinic"
    },
    "2": {
      "day": 2,
      "period": "pm",
      "code": "AF2",
      "title": "Pediatria",
      "professor": "Fernanda Ribeiro",
      "location": "Centro de Saúde Santa Rosa",
      "regional": "Pampulha",
      "source": "fixed",
      "kind": "clinic"
    },
    "3": {
      "day": 2,
      "period": "pm",
      "code": "AF3",
      "title": "Cirurgia",
      "professor": "Leonardo Gasbarro",
      "location": "CEASC",
      "regional": "",
      "source": "fixed",
      "kind": "clinic"
    },
    "4": {
      "day": 2,
      "period": "pm",
      "code": "AF4",
      "title": "Cirurgia",
      "professor": "Daniela Alves",
      "location": "CEASC",
      "regional": "",
      "source": "fixed",
      "kind": "clinic"
    },
    "5": {
      "day": 2,
      "period": "pm",
      "code": "AF5",
      "title": "Clínica Médica",
      "professor": "Miguel Ângelo",
      "location": "Ambulatório da Igreja do Carmo Sion",
      "regional": "",
      "source": "fixed",
      "kind": "clinic"
    }
  }
} },
  specialtyClinics: SPECIALTY_CLINICS,
  extraCatalog: EXTRA_CATALOG,
  sourcePdf
};
export default periodDataset;
